import styled from "rn-css";

//Wide
export const StyledWideContent = styled.View`
	display: flex;
	flex-direction: column;
	align-self: stretch;
`;

export const StyledWideFooter = styled.View`
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
	align-self: stretch;
`;

export const StyledButtonContainer = styled.View`
	display: flex;
	flex-direction: row;
	gap: 1.5rem;
	align-self: stretch;
`;

//Narrow
export const StyledNarrowButton = styled.View`
	display: flex;
	width: 31.25rem;
	flex-direction: column;
	align-items: flex-start;
	align-self: stretch;
	gap: 1rem;
`;

export const StyledNarrowCreateButton = styled.View`
	display: flex;
	width: 100%;
	gap: 1rem;
`;

export const StyledNarrowTextContent = styled.View`
	display: flex;
	flex-direction: column;
	flex: 1 0 0;
	margin-top: -5px;
`;
